// src/components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { localStorageName } from "../core/constants";

export default function PrivateRoute({ children }) {
//   const { isAuthenticated } = useAuth();

  const token = localStorage.getItem(localStorageName);

  if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
}
